import { h, Component } from 'preact';
import Router from 'preact-router';
import Header from './header';
import Footer from './footer';
import Home from './home';
import AvailableSessions from './available-sessions';
import BookSession from './book-session';
import About from './about';
import Testimonials from './testimonials';
import Contact from './contact';

export default class App extends Component {
  render() {
    return (
      <div id="app">
        <Header />
        <div class="scrollable">
          <Router>
            <Home path="/" />
            <AvailableSessions path="/book" />
            <BookSession path="/book/:ts" />
            <About path="/about" />
            <Testimonials path="/testimonials" />
            <Contact path="/contact" />
          </Router>
        </div>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/app.js